import { Navigate, Outlet } from "react-router-dom";
import Sidebar from "../pages/navbar/Sidebar";
import { decryptToken } from "../utils/tokenSecure";

const PrivateRoute = () => {
  const token = decryptToken();
  return token ? <><Sidebar /><Outlet /></> : <Navigate to="/signin" replace />;
};

export default PrivateRoute;
